import { render, staticRenderFns } from "./UploadAddressProof.vue?vue&type=template&id=99ff20f0&scoped=true"
import script from "./UploadAddressProof.vue?vue&type=script&lang=js"
export * from "./UploadAddressProof.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ff20f0",
  null
  
)

export default component.exports